import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataPrimeiraVisualizacao = (): TabelaColuna => ({
  Chave: 'dataPrimeiraVisualizacao',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataPrimeiraVisualizacao)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data 1ª Acesso.</div>
})
